import React from "react";
import Logo from "../../components/Logo";

const AuthHeader = () => {
    return (
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <div className="flex justify-center w-full">
                <a href="/">
                <Logo width={90} height={90} />
                </a>
            </div>
        </div>
    );
};

export default AuthHeader;
